/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';
var isArguments = function (value) {
    return isType(value, 'Arguments');
};
export default isArguments;
//# sourceMappingURL=is-arguments.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-arguments.js
// module id = 484
// module chunks = 3